<v-card variant="outlined" width="870">
    <div class="header">
        <img :src="logo" />
        <div class="header-text">International Feedback Management</div>
    </div>
    <div class="ma-4"><slot></slot></div>
    <div class="footer"></div>
</v-card>
